import React, { useRef } from 'react';
import { useTheme } from '../../context/ThemeContext';
import './AccentPicker.css';

const ACCENT_META = [
  { key: 'blue',   label: 'Electric Blue', color: '#5b9dff' },
  { key: 'green',  label: 'Emerald',       color: '#13dfa0' },
  { key: 'violet', label: 'Violet',        color: '#8b5cf6' },
  { key: 'amber',  label: 'Amber',         color: '#fbbf24' },
  { key: 'rose',   label: 'Rose',          color: '#fb2c54' },
  { key: 'cyan',   label: 'Cyan',          color: '#06b6d4' },
  { key: 'pink',   label: 'Hot Pink',      color: '#f43fa5' },
  { key: 'custom', label: 'Custom',        color: null },
];

export default function AccentPicker() {
  const { accent, setAccent, customColor, setCustomColor } = useTheme();
  const colorInputRef = useRef(null);

  function handleCustomChange(e) {
    const hex = e.target.value;
    setCustomColor(hex);
    setAccent('custom');
  }

  return (
    <div className="accent-picker" role="radiogroup" aria-label="Accent color">
      {ACCENT_META.map(({ key, label, color }) => {
        if (key === 'custom') {
          const displayColor = customColor || '#888888';
          return (
            <div key="custom" className="accent-picker__custom-wrap">
              <button
                className={`accent-picker__dot ${accent === 'custom' ? 'accent-picker__dot--active' : ''}`}
                style={{ '--dot-color': displayColor, background: displayColor }}
                onClick={() => { setAccent('custom'); colorInputRef.current?.click(); }}
                role="radio"
                aria-checked={accent === 'custom'}
                aria-label="Custom color"
                type="button"
                title="Custom color"
              />
              <input
                ref={colorInputRef}
                type="color"
                className="accent-picker__color-input"
                value={displayColor}
                onChange={handleCustomChange}
                aria-label="Pick custom accent color"
              />
            </div>
          );
        }

        return (
          <button
            key={key}
            className={`accent-picker__dot ${accent === key ? 'accent-picker__dot--active' : ''}`}
            style={{ '--dot-color': color }}
            onClick={() => setAccent(key)}
            role="radio"
            aria-checked={accent === key}
            aria-label={label}
            type="button"
            title={label}
          />
        );
      })}
    </div>
  );
}
